import { getFromIndexedDB } from "./indexedDb.js";

const getOrSetGraph = async (topic) => {
    // Only use IndexedDB cache, no server persistence
    const cachedGraph = await getFromIndexedDB(topic);
    if (cachedGraph !== undefined) {
        return cachedGraph;
    }

    // Return null if no cached graph exists - let the calling code handle building a new one
    return null;
};

export default getOrSetGraph;